export const TRADING_SESSION_CHANNEL = 'snappy.trading-session.v1';
export const TRADING_SESSION_LOCAL_EVENT =
    'snappy:trading-session:refresh';

export type TradingSessionBroadcastMessage =
    | { type: 'changed' }
    | { type: 'oauth-authority-cleared' }
    | { type: 'logout' };

export function broadcastTradingSession(
    message: TradingSessionBroadcastMessage,
): void {
    window.dispatchEvent(
        new CustomEvent<TradingSessionBroadcastMessage>(
            TRADING_SESSION_LOCAL_EVENT,
            { detail: message },
        ),
    );
    if (typeof BroadcastChannel === 'undefined') return;
    const channel = new BroadcastChannel(TRADING_SESSION_CHANNEL);
    channel.postMessage(message);
    channel.close();
}
